import { Header } from '../../components/Shared/NavBar/Header.jsx';
import { TracingCalificacion } from '../../components/Tracing/TracingCalificacion.jsx';
export const TracingCalificacionView = () => {
  return (
    <>
      <Header />
      <TracingCalificacion/>
    </>
  );
};